













































































































































































































































































































































































import _ from 'lodash';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Typ } from '@/modules/ciselnik/dilenske/typ';
import { ModelNv } from '@/modules/ciselnik/noveVozy/modelNv';
import { Barva } from '@/modules/ciselnik/dilenske/barva';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openSelectList, openList, openRouteAndReplace } from '@/main/router/routerPath';
import { editFactory } from '@/main/pages';
import { CREATE } from '@/main/store/listEditTypes';
import { editMutations as ozakazkaEditMutations } from '@/modules/servis/ozakazka/store/types';
import { editMutations as checkinEditMutations } from '@/modules/servis/checkIn/store/types';
import { NAME as OZAKAZKA_NAME } from '@/modules/servis/ozakazka/constants';
import { showAlert } from '@/main/utils/notifications';
import { apiProvider } from '@/modules/kartoteka/vozidlo/api';
import { NAME as CHECKIN } from '@/modules/servis/checkIn/constants';
import { NAME as SKLAD_PNEU } from '@/modules/sklad/pneuSklad/constants';
import { NAME as DOKLAD } from '@/modules/servis/doklad/constants';
import { forceFileDownload, validateFiletype } from '@/main/utils/fileHelper';
import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';
import { Cell, getColumnsRowMapObject } from '@/main/utils/table';
import { dataMapper } from '@/main/utils/dataMapper';
import { UserRole, FILE_TYPE, MAXIMUM_FILE_SIZE } from '@/main/components/constants';

import { printButton, previewButton, saveButton, deleteButton, editButton } from '@/main/utils/tableOperations';

import { editActions, editMutations } from './store/types';
import {CUSTOMER_CONTACT_DETAILS,
	NAME, VOZIDLO_DATA_TYPE, DUPLICITY_TABLE, VOZIDLO_MERGE, VOZIDLO_CDB, VEHICLE_HISTORY, CUSTOMER_FILES, VEHICLE_INSURANCE_DETAILS,
	CUSTOMER_OFFERS, INSURANCE_REPORT, MENU_CODE, TAB_NAMES, TABS, DEFAULT_START_MONTH, DMS_AS_GOLDEN_ACCOUNT_ID_PREFIX, TENANT_NAME
} from './constants';
import { store } from './store/edit';
import CreateModal from '../../servis/zakazka/components/CreateModal.vue';
import { Partner } from '../partner';
import SmsEmailModal from '../smsEmailModal/SmsEmailModal.vue';
import { EMAIL_TYP_PZN, SMS_TYP_PZN } from '../smsEmailModal/constants';
import { DoServisuPredal } from './activity/doServisuPredal';
import InsuranceModal from './components/InsurancePolicyDetails.vue';

export default editFactory(NAME, store).extend({
	components: {
		CreateModal,
		SmsEmailModal,
		PartnerSelect: Partner.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		TypSelect: Typ.components.Select,
		NvmodelSelect: ModelNv.components.Select,
		BarvaSelect: Barva.components.Select,
		InsuranceModal,
	},
	props: {
		fromMerge: { type: Boolean, default: false },
		updateData: { type: Object, default: () => { } },
	},
	data() {
		return {
			apiProvider,
			emailTypPzn: EMAIL_TYP_PZN.VOZIDLO,
			smsTypPzn: SMS_TYP_PZN.VOZIDLO,
			savedZakaznikId: null as number | null,
			visibleSmsEmailModal: false,
			showDialog: false,
			dependencies: {
				[CUSTOMER_CONTACT_DETAILS]: CUSTOMER_CONTACT_DETAILS,
				[DUPLICITY_TABLE]: DUPLICITY_TABLE,
				[VEHICLE_HISTORY]: VEHICLE_HISTORY,
				[CUSTOMER_FILES]: CUSTOMER_FILES,
				[VEHICLE_INSURANCE_DETAILS]: VEHICLE_INSURANCE_DETAILS,
				[CUSTOMER_OFFERS]: CUSTOMER_OFFERS,
				[INSURANCE_REPORT]: INSURANCE_REPORT
			},
			visibleSaveButton: true as boolean,
			otp: null as number | null,
			saveButton,
			deleteButton,
			printButton,
			previewButton,
			tabNames: TAB_NAMES,
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.HlavniUdaje)) tabItems.push(TAB_NAMES.HLAVNIUDAJE);
			if (this.hasTabAccess(MENU_CODE, TABS.DalsiInfo)) tabItems.push(TAB_NAMES.DALSIINFO);
			if (this.hasTabAccess(MENU_CODE, TABS.UpdateDetails)) tabItems.push(TAB_NAMES.UPDATEDETAILS);

			return _.pick(TABS, tabItems);
		},
		dependeciesByFilter(): string[] {
			const deps = _.filter(this.dependencies, (key) => !this.dependentTables[key].loadByEntityId);
			if (this.dmsSys.EnableTaiwanPrp) {
				return deps.filter((key) => key !== CUSTOMER_OFFERS);
			}
			return deps;
		},
		duplicityTitle(): string {
			return this.LocalizePopisostatni('VozidloCielHodnoty');
		},
		mutationsMappers(): Record<string, string> {
			return {
				zakaznik: `${this.storeUri}/${editMutations.VOZIDLO_ZAKAZNIK_SELECT_MAPPER}`,
				model: `${this.storeUri}/${editMutations.VOZIDLO_MODEL_SELECT_MAPPER}`,
				barva: `${this.storeUri}/${editMutations.VOZIDLO_BARVA_SELECT_MAPPER}`,
				prodejce: `${this.storeUri}/${editMutations.VOZIDLO_PRODEJCE_SELECT_MAPPER}`,
				pojistovna: `${this.storeUri}/${editMutations.VOZIDLO_POJISTOVNA_SELECT_MAPPER}`,
				leasing: `${this.storeUri}/${editMutations.VOZIDLO_LEASING_SELECT_MAPPER}`,
			};
		},
		actionMappers(): Record<string, string> {
			return {
				typKod: `${this.storeUri}/${editActions.VOZIDLO_TYP_KOD_SELECT_MAPPER}`,
			};
		},
		typKodFilter(): Record<string, any> {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Typkod: this.Typkod,
				ModelRok: this.ModelRok,
			};
		},
		nvmodelFilter(): Record<string, any> {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Typkod: this.Typkod,
				DoplnekMk: this.DoplnekMk,
				ModelRok: this.ModelRok,
				Ddp: null,
			};
		},
		vozidloExists(): boolean {
			return this.VozidloId! > 0;
		},
		partnerSelectFilter(): object {
			return {
				ZakaznikId: this.ZakaznikId,
				ZakaznikKonId: this.ZakaznikkonId,
				Ozakazka: true,
				Create: this.ZakaznikkonId && this.dependentTables.MergeZakaznik.rows.length === 0 && !this.ZakaznikId,
			};
		},
		isFromOzakazka(): boolean {
			const uri = this.ancestorUri(3);
			return !!uri && uri.includes(OZAKAZKA_NAME);
		},
		vozidloCDBFilter(): object {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				KaroserieNr: this.KaroserieNr,
				Spz: this.Spz,
				BarvaText: this.BarvaText,
				BarvaKod: this.BarvaKod,
				ModelRok: this.ModelRok,
				ModelKod: this.Typkod,
				MotorNr: this.MotorNr,
			};
		},
		isInfoVisible(): boolean {
			return (this.pracovnik.PracovnikOzn === UserRole.CALL_CENTER && this.VehicleUpdateData.IsUpdateRC);
		},
		extraButtons(): {} {
			return { ...editButton(this.editButtonClick), ...saveButton(this.insurancePolicyFilesDownload) };
		},
	},
	watch: {
		KaroserieNr(val) {
			this.titleDetail = val;
		},
	},
	methods: {
		// async loadData() {
		// 	this.startLoading();
		// 	if (this.isCreateMode) {
		// 		const resp = await this.default();
		// 		if (resp instanceof Error) {
		// 			this.$router.back();
		// 		}
		// 	} else {
		// 		await this.entity();
		// 		this.fetchTableData(this.dependeciesByFilter);
		// 	}
		// 	await this.loadedData();
		// 	let schemaDependecies = this.dependeciesByFilter;
		// 	if (this.isEditMode || this.isViewMode) {
		// 		this.fetchTableSchemaData(this.dependenciesById);
		// 	} else {
		// 		schemaDependecies = [...this.dependeciesByFilter, ...this.dependenciesById];
		// 	}
		// 	await this.fetchTableSchemas(schemaDependecies);
		// 	this.endLoading();
		// },
		validateExtWarrantyDat() {
			if (((this.ExtWarrantyStartDat != null || this.ExtWarrantyEndDat != null) && this.GarKonecDat != null)
				&& ((this.ExtWarrantyStartDat && this.GarKonecDat && this.GarKonecDat >= this.ExtWarrantyStartDat)
					|| (this.ExtWarrantyEndDat && this.GarKonecDat && this.GarKonecDat >= this.ExtWarrantyEndDat))) {
				this.showErrorAlert({
					message: `${this.LocalizeChyboveHlasky('EndWarrantyError')}`,
					localizeMessage: false,
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: { type: 'error' },
				});
			} else if (this.ExtWarrantyStartDat != null && this.ExtWarrantyEndDat != null
				&& this.ExtWarrantyStartDat >= this.ExtWarrantyEndDat) {
				this.showErrorAlert({
					message: `${this.LocalizeChyboveHlasky('ExtendedWarrantyError')}`,
					localizeMessage: false,
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: { type: 'error' },
				});
			}
		},
		async rejectRequest() {
			if (this.VehicleUpdateData.Remarks === null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('RejectRmk'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			} else {
				this.startLoading();
				await apiProvider.rejectDetails(this.VehicleUpdateData);
				await this.refreshTable(VEHICLE_HISTORY);
				this.endLoading();
				showAlert({
					message: this.LocalizeChyboveHlasky('RejectRec'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
		},
		async approveChangeRequest() {
			this.startLoading();
			const result = await apiProvider.approveDetails(this.VehicleUpdateData);
			if (result instanceof Error) {
				this.endLoading();
			}
			await this.refreshTable(VEHICLE_HISTORY);
			this.endLoading();
			showAlert({
				message: this.LocalizeChyboveHlasky('ApproveRec'),
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: { type: 'info' },
			});
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		afterCdBSelect({ row }: any) {
			this.setCDBVozidlo({ cdbVozidloId: row.CDB_VOZIDLO_ID });
		},
		isOTPRequired() {
			if (this.VozidloId != null && this.VozidloId !== -1) {
				this.isTextchanged = true;
				this.visibleSaveButton = false;
			}
		},
		async spzExit() {
			this.isOTPRequired();
			const { data } = await apiProvider.spzExit(this.edit);
			if (data.RecordCount > 0) {
				this.refreshTable(this.dependentTables.MergeVozidlo.name);
				await openEdit(VOZIDLO_MERGE, PageMode.EDIT, { id: this.VozidloId!, kontaktId: null, fromVinSpzExit: true });
			}
		},
		async vinExit() {
			this.isOTPRequired();
			const { data: vinExistResp } = await apiProvider.karoserieNrExit(this.edit);
			if (vinExistResp) {
				if (vinExistResp.RecordCount > 1) {
					await this.refreshTable(this.dependentTables.MergeVozidlo.name);
					await openEdit(VOZIDLO_MERGE, PageMode.EDIT, { id: this.VozidloId!, kontaktId: null, fromVinSpzExit: true });
				} if (vinExistResp.RecordCount === 1) {
					await openRouteAndReplace(NAME, PageMode.EDIT, { id: vinExistResp.VozidloId });
				}
				this.ModelRok = vinExistResp.ModelRok;
				this.VyrobekvozOzn = vinExistResp.VyrobekvozOzn;
			}
		},
		onMergeVozidloChange(data: any) {
			const mutation = this.isFromOzakazka ? ozakazkaEditMutations.SAVE_OZAKAZKA_AFTER_MERGE : checkinEditMutations.UPDATE_CHECKIN_AFTER_MERGE;
			return this.$store.commit(`${this.ancestorUri(3)}/${mutation}`, data);
		},
		loadedData() {
			if (this.Oznam) {
				showAlert({
					message: this.Oznam,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
			if (this.fromMerge) {
				this.vozidloKonMerge(this.updateData);
			}
			this.savedZakaznikId = this.ZakaznikId;
			if (this.isViewMode && this.isInfoVisible) {
				this.activeTabName = 'UpdateDetails';
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertReqRaisedForVehicle'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
			if (this.isViewMode && this.isInfoVisible) {
				this.activeTabName = 'UpdateDetails';
			}
			if(this.isCreateMode){
				this.KaroserieNr = this.props.karoserieNr;
				this.Spz = this.props.spz;
				this.VyrobekvozOzn = this.props.vyrobekvozOzn;
				this.Typkod = this.props.typkod;
				this.TypkodText = this.props.typkodText;
				this.ModelRok = this.props.modelRok;
				this.TablPozice = this.props.tablPozice;
				this.BarvaKod = this.props.barvaKod;
				this.BarvaText = this.props.barvaText;
				this.ProdejDat = this.props.prodejDat;
				this.GarPzn = this.props.garPzn;
				this.TpNr = this.props.tpNr;
				this.VyrobaRok = this.props.vyrobaRok;
				this.MotorNr = this.props.motorNr;
				this.PalivoPzn = this.props.palivoPzn;
				this.OvkategPzn = this.props.ovkategPzn;
				this.OvdruhPzn = this.props.ovdruhPzn;
				this.ZakaznikId = this.props.zakaznikId;
				this.ZakaznikIdText = this.props.zakaznikIdText;
				this.Objem = this.props.objem;
				this.Vykon = this.props.vykon;
				this.VozidloId = this.props.vozidloId;
				this.ContactDetails = this.props.contactDetails;
			}
			this.recomputeHash();
		},
		async vozidloSave() {
			this.KatalyzatorPzn = 1;
			this.startLoading();
			let result;
			if (this.VozidloId !== null && this.VozidloId !== -1) {
				const vozidlo = await apiProvider.getVozidlo(this.VozidloId);
				await this.createVozidloData(vozidlo);
				if (vozidlo?.headers) {
					if (this.isChangeRequestInitialed()) {
						showAlert({
							message: this.LocalizeChyboveHlasky('ChangeReqRaised'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: { type: 'info' },
						});
					}
					result = await this.save();
					this.otp = null;
					this.endLoading();
				}
			} else {
				if (this.isChangeRequestInitialed()) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ChangeReqRaised'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
				}
				result = await this.save();
				this.otp = null;
				this.endLoading();
			}
			if (this.isCreateMode && this.isFromMerge && result.headers) {
				await this.onMergeVozidloChange({
					VozidloId: Number(result.headers.location.split('=')[1]),
					Spz: this.Spz,
					KaroserieNr: this.KaroserieNr,
					TypkodText: this.TypkodText,
				});
			} else if (this.isFromMerge && this.isEditMode) {
				await this.onMergeVozidloChange({
					VozidloId: this.VozidloId,
					Spz: this.Spz,
					KaroserieNr: this.KaroserieNr,
					TypkodText: this.TypkodText,
				});
			} else if (this.parentUri && this.parentUri.includes(CHECKIN)) {
				this.$store.commit(`${this.parentUri}/${checkinEditMutations.UPDATE_CHECKIN_AFTER_MERGE}`, {
					VozidloId: Number(result.headers.location.split('=')[1]),
					Spz: this.Spz,
					KaroserieNr: this.KaroserieNr,
					TypkodText: this.TypkodText,
				});
			}
			this.endLoading();
		},
		async validateCustomerFilesAndSaveVozidlo() {
			if (this.isTextchanged === true) {
				this.visibleSaveButton = true; // Filtering the Otp condition as sms service not yet implemented
				if (this.isEditMode && !this.visibleSaveButton) {
					const message = this.LocalizeChyboveHlasky('InputOTP');
					this.visibleSaveButton = false;
					showAlert({
						message,
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					this.endLoading();
				} else {
					this.vozidloSave();
				}
			} else {
				this.vozidloSave();
			}
		},
		async saveClick() {
			if ((this.ExtWarrantyStartDat != null && this.ExtWarrantyEndDat != null && this.ExtWarrantyStartDat >= this.ExtWarrantyEndDat)
				|| (this.GarKonecDat != null && ((this.ExtWarrantyStartDat && this.GarKonecDat && this.GarKonecDat >= this.ExtWarrantyStartDat)
					|| (this.ExtWarrantyEndDat && this.GarKonecDat && this.GarKonecDat >= this.ExtWarrantyEndDat)))) {
				this.validateExtWarrantyDat();
				return;
			}
			if (this.isCreateMode) {
				await this.fetchTableData([DUPLICITY_TABLE]);
				if (this.dependentTables.MergeVozidlo.rows.length > 0) {
					this.showDialog = true;
				} else {
					this.validateCustomerFilesAndSaveVozidlo();
				}
			} else {
				this.validateCustomerFilesAndSaveVozidlo();
			}
		},
		isChangeRequestInitialed() {
			if(this.VehicleUpdateData==null) 
				return false;
			return this.VehicleUpdateData.SpzOld !== this.VehicleUpdateData.SpzNew;
		},
		async createApiStoreFetch(goBack = true) {
			if (this.isFromMerge && this.isCreateMode) {
				const resp = await this.$store.dispatch(`${this.storeUri}/${CREATE}`, { goBack });
				const VozidloId = resp.headers.location.split('=')[1];
				await this.onMergeVozidloChange({
					VozidloId,
				});
				return resp;
			}
			return this.$store.dispatch(`${this.storeUri}/${CREATE}`, { goBack });
		},
		openHistorieOprav() {
			this.openData(VOZIDLO_DATA_TYPE.HISTORIEOPRAV);
		},
		openObratyOprav() {
			this.openData(VOZIDLO_DATA_TYPE.OBRATYOPRAV);
		},
		openServiceKey() {
			this.openData(VOZIDLO_DATA_TYPE.SERVICEKEY);
		},
		openPneuSklad() {
			if (this.RelatedData.PneusetNaSkladePoc === 1) {
				openEdit(SKLAD_PNEU, PageMode.EDIT, { id: this.RelatedData.PneuskladId! });
			} else {
				openList(SKLAD_PNEU, {
					filter: {
						VozidloId: this.VozidloId,
						VozidloText: this.KaroserieNr,
						SkladpneuOzn: null,
					},
				});
			}
		},
		openData(dataType: string) {
			openList(
				dataType,
				{
					filter: { VozidloId: this.VozidloId, type: dataType, VIN: this.KaroserieNr },
				},
			);
		},
		openCreateModalZakazka() {
			this.$refs.createModal && (this.$refs.createModal as any).createClickFun();
		},
		createZavada() {
			openEdit(
				VOZIDLO_DATA_TYPE.ZAVADA,
				PageMode.CREATE,
				{
					filter: {
						VozidloId: this.VozidloId,
					},
				},
			);
		},
		openZavada() {
			openList(
				VOZIDLO_DATA_TYPE.ZAVADA,
				{
					filter: {
						VozidloId: this.VozidloId,
					},
				},
			);
		},
		openSda() {
			openList(
				VOZIDLO_DATA_TYPE.SDA,
				{
					filter: {
						KaroserieNr: this.KaroserieNr,
						VyrobekvozOzn: this.VyrobekvozOzn,
						type: VOZIDLO_DATA_TYPE.SDA,
					},
				},
			);
		},
		openDoServisuPredalList() {
			openList(
				DoServisuPredal.name,
				{
					filter: {
						VozidloId: this.VozidloId,
					},
					previousStoreUri: this.storeUri,
					previousEntityId: this.VozidloId,
				},
			);
		},
		openDoklady() {
			openList(
				DOKLAD,
				{
					filter: {
						VozidloId: this.VozidloId,
						VyrobekvozOzn: this.VyrobekvozOzn,
						VozidloVin: this.KaroserieNr,
						Spz: this.Spz,
						UzavreniDatOd: null,
						ProvozovnaId: null,
					},
				},
			);
		},
		onVyrobekVozUpdate() {
			if (this.VyrobekvozOzn) {
				this.Typkod = null;
				this.TypkodText = null;
				this.DoplnekMk = null;
				this.ModelRok = null;
			}
		},
		async createVozidloData(vozidlo: any) {
			this.VehicleUpdateData.SpzOld = vozidlo.data.Spz;
			this.VehicleUpdateData.SpzNew = this.Spz;
			const vozidloData: any = { VozidloId: this.VozidloId, SpzNew: this.Spz, SpzOld: vozidlo.data.Spz };
			this.startLoading();
			await apiProvider.updateVozidloOngoingEditData(vozidloData);
			this.endLoading();
		},
		async submitUpload() {
			const validateFile = validateFiletype(this.fileList[0], MAXIMUM_FILE_SIZE, FILE_TYPE);
			if (!validateFile.result) {
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.startLoading();
			const { data: isFileUpload } = await apiProvider.saveDocument(this.fileList[0], this.ZakaznikId);	
			if (!isFileUpload) {
				this.endLoading();
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
			await this.refreshTable(CUSTOMER_FILES);
			this.endLoading();
		},
		async vehicleFilesDownload(e: Event, cells: Cell[]) {
			const MappedRow = getColumnsRowMapObject(this.dependentTables.CustomerFiles.columns, cells) as any;
			this.startLoading();
			const file = await apiProvider.getDocuments(MappedRow.FILE_ID);
			const url = `data:application/octet-stream;base64,${file.data}`;
			forceFileDownload(url, MappedRow.FILE_NAME);
			this.endLoading();
			await this.refreshTable(CUSTOMER_FILES);
		},
		async insurancePolicyFilesDownload(e: Event, cells: Cell[]) {
			const mappedRow = getColumnsRowMapObject(this.dependentTables.VehicleInsuranceDetails.columns, cells) as any;
			this.startLoading();
			const url = `data:application/octet-stream;base64,${mappedRow.POLICY_DOCUMENT}`;
			forceFileDownload(url, mappedRow.POLICY_DOCUMENT_FILE_NAME);
			this.endLoading();
		},

		async vehicleFilesDelete(e: Event, cells: Cell[]) {
			await apiProvider.deleteDocuments(cells[0]);
			await this.refreshTable(CUSTOMER_FILES);
		},

		async sendOTP() {
			const vehicleOtpDto = {
				zakaznikId: this.ZakaznikId,
				vozidloId: this.KaroserieNr,
			};
			let messageAlert;
			this.startLoading();
			const { data: sendSms } = await apiProvider.sendOTP(objectToCamelCaseShallow(vehicleOtpDto));
			if (sendSms) {
				this.visibleSaveButton = false;
				messageAlert = this.LocalizeChyboveHlasky('OTPSent');
			} else {
				this.visibleSaveButton = false;
				messageAlert = this.LocalizeChyboveHlasky('OTPNotSent');
			}
			this.visibleSaveButton = false;
			this.endLoading();
			showAlert({
				message: messageAlert,
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: { type: 'info' },
			});
		},

		async verifyOTP() {
			let messageAlert;
			if (this.otp !== null) {
				const vehicleOtpDto = {
					otp: this.otp,
					zakaznikId: this.ZakaznikId,
				};
				this.startLoading();
				const { data: isOTPverified } = await apiProvider.verifyOTP(objectToCamelCaseShallow(vehicleOtpDto));
				if (isOTPverified) {
					this.visibleSaveButton = true;
					messageAlert = this.LocalizeChyboveHlasky('OTPVerified');
				} else {
					this.otp = null;
					this.visibleSaveButton = false;
					messageAlert = this.LocalizeChyboveHlasky('OTPInvalid');
				}
			} else {
				this.visibleSaveButton = false;
				messageAlert = this.LocalizeChyboveHlasky('InputOTP');
			}

			this.endLoading();
			showAlert({
				message: messageAlert,
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: { type: 'info' },
			});
		},
		async getDetailsForPolicy() {
			this.policyPopupTitle = `${this.LocalizeChyboveHlasky('addPolicyTitle')} ${this.KaroserieNr}`;
			this.policyUpdateMode = false;
			this.startLoading();
			const { data: insurancePolicy } = await apiProvider.getDetailsForInsurancePolicy({ VozidloId: this.VozidloId, VIN: this.KaroserieNr });
			if (insurancePolicy) {
				this.insurancePolicyDetails = insurancePolicy;
				this.showPolicyDialog = true;
			}
			this.endLoading();
		},
		async editButtonClick(e: any, cells: any) {
			const MappedRow = getColumnsRowMapObject(this.dependentTables.VehicleInsuranceDetails.columns, cells) as any;
			this.policyPopupTitle = `${this.LocalizeChyboveHlasky('updatePolicyTitle')} ${MappedRow.VIN}`;
			this.startLoading();
			const { data: updateInsuranceDtlReps } = await apiProvider.getInsuranceDetailsForUpdate(MappedRow.ID);
			this.endLoading();
			if (updateInsuranceDtlReps) {
				this.policyUpdateMode = true;
				this.insurancePolicyDetails = updateInsuranceDtlReps;
				this.showPolicyDialog = true;
			}
		},
		handleChangeForInsuranceEvaluation(file: Record<string, any>) {
			this.fileListEV = [file];
		},
		handleRemoveForInsuranceEvaluation(file: File, fileListEV: []) {
			this.fileListEV = fileListEV;
		},
		async submitUploadForInsuranceEvaluation() {
			const validateFile = validateFiletype(this.fileListEV[0], MAXIMUM_FILE_SIZE, FILE_TYPE);
			if (!validateFile.result) {
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.startLoading();
			const { data: isFileUpload } = await apiProvider.submitUploadForInsuranceEvaluation(this.fileListEV[0], this.VozidloId);
			if (!isFileUpload) {
				this.endLoading();
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
			this.fileListEV = [];
			await this.refreshTable(INSURANCE_REPORT);
			this.endLoading();
		},
		async InsuranceEvaluationFilesDownload(e: Event, cells: Cell[]) {
			const MappedRow = getColumnsRowMapObject(this.dependentTables.InsuranceReport.columns, cells) as any;
			this.startLoading();
			const file = await apiProvider.getInsuranceEvaluationDocuments(MappedRow.FILE_ID);
			const url = `data:application/octet-stream;base64,${file.data}`;
			forceFileDownload(url, MappedRow.FILE_NAME);
			this.endLoading();
			await this.refreshTable(CUSTOMER_FILES);
		},
	},
});
